const SAFE_FIELD_NAME = /^[A-Za-z_][A-Za-z0-9_]*$/;
const UNSAFE_FIELD_NAMES = new Set(['__proto__', 'prototype', 'constructor']);

/**
 * Validates that a field name is safe to use for property access.
 * @param field The field name to validate
 * @returns true if the field name is safe, false otherwise
 */
export const isSafeFieldName = (field: string): boolean =>
  SAFE_FIELD_NAME.test(field) && !UNSAFE_FIELD_NAMES.has(field);
